import Add from './add';

export default {
    Add
}